import React from 'react';
import { motion } from 'framer-motion';
import { Music, Bike, Plane } from 'lucide-react';
export function Slide09DigitalService() {
  const services = [{
    icon: Music,
    name: 'Spotify',
    offer: 'Premium periods',
    color: '#1DB954'
  }, {
    icon: Bike,
    name: 'VOI',
    offer: 'Free rides',
    color: '#F46C5E'
  }, {
    icon: Plane,
    name: 'VING',
    offer: 'Travel discounts',
    color: '#FF7B00'
  }];
  return <div className="flex flex-col h-full justify-center max-w-6xl mx-auto w-full" data-id="element-117">
      <motion.h2 className="text-5xl font-bold text-white mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-118">
        Digital Service Sampling
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-119">
        {services.map((service, i) => <motion.div key={i} initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.2,
        type: 'spring'
      }} className="flex flex-col items-center p-10 rounded-3xl bg-white/5 border border-white/10 hover:border-white/30 transition-colors" data-id="element-120">
            <motion.div className="w-24 h-24 rounded-full flex items-center justify-center mb-8" style={{
          backgroundColor: service.color
        }} animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          delay: i
        }} data-id="element-121">
              <service.icon className="w-12 h-12 text-white" data-id="element-122" />
            </motion.div>

            <h3 className="text-3xl font-bold text-white mb-2" data-id="element-123">
              {service.name}
            </h3>
            <p className="text-xl text-[#ffd700] mb-6" data-id="element-124">{service.offer}</p>

            <div className="w-full h-px bg-white/10 mb-6" data-id="element-125" />

            <ul className="text-white/70 space-y-2 text-center" data-id="element-126">
              <li data-id="element-127">Coupon codes</li>
              <li data-id="element-128">No logistics</li>
              <li data-id="element-129">Scales globally</li>
            </ul>
          </motion.div>)}
      </div>
    </div>;
}